import { render } from "./SelectPatient.vue?vue&type=template&id=f394b3a8&scoped=true&lang=pug"
import script from "./SelectPatient.vue?vue&type=script&lang=js"
export * from "./SelectPatient.vue?vue&type=script&lang=js"

import "./SelectPatient.vue?vue&type=style&index=0&id=f394b3a8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f394b3a8"]])

export default __exports__